<template>
  <v-dialog
    v-model="internalDialog"
    max-width="420"
    :persistent="false"
    @click:outside="close"
  >
    <v-card>
      <v-card-title class="headline">
        Update {{ dateTypeLabel }}
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isValid">
          <date-picker
            v-model="localDate"
            :hide-details="false"
            :rules="[dateRequired]"
            outlined
            clearable
          />
          <v-textarea
            v-model="localNote"
            label="Note"
            rows="3"
            auto-grow
            outlined
            class="mt-4"
            placeholder="Add a note"
            :rules="[noteRequired]"
          />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!localDate || !localNote"
          @click="confirm"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue'

export default {
  name: 'UpdateTaskDateDialog',

  components: {
    DatePicker
  },

  props: {
    value: {
      type: Boolean,
      required: true
    },
    taskId: {
      type: [String, Number],
      required: true
    },
    prototypeId: {
      type: [String, Number],
      required: true
    },
    dateType: {
      type: String,
      required: true
    },
    dateChange: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      localDate: this.dateChange,
      localNote: '',
      noteRequired (v) {
        return !!v || 'กรุณาระบุโน๊ต'
      },
      dateRequired (v) {
        return !!v || 'กรุณาระบุวันที่'
      },
      isValid: true
    }
  },

  computed: {
    internalDialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    dateTypeLabel () {
      const map = {
        startDate: 'Start Date',
        dueDate: 'Due Date',
        completedAt: 'Completed Date'
      }
      return map[this.dateType] || 'Date'
    }
  },

  watch: {
    dateChange (val) {
      this.localDate = val
    },
    internalDialog (val) {
      if (!val) {
        this.resetForm()
      }
    }
  },

  methods: {
    close () {
      this.$emit('close')
      this.internalDialog = false
    },

    confirm () {
      if (!this.$refs.form.validate()) return
      this.$emit('confirm', {
        taskId: this.taskId,
        prototypeId: this.prototypeId,
        dateType: this.dateType,
        dateChange: this.localDate,
        note: this.localNote
      })
      this.close()
    },

    resetForm () {
      this.localDate = null
      this.localNote = ''
    }
  }
}
</script>
